import { render, staticRenderFns } from "./ConnectWithoutContactIcon.vue?vue&type=template&id=1775ad48&scoped=true&"
import script from "./ConnectWithoutContactIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ConnectWithoutContactIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1775ad48",
  null
  
)

export default component.exports